import { ModalComponent } from '@propertyfinder/modal';
import { FunctionComponent, h } from 'preact';

import { SaveSearchFormPropsInterface } from 'common/module/save-search/form/props.interface';

import { SaveSearchFormSectionComponent } from './section/component';

export const SaveSearchFormTemplate: FunctionComponent<SaveSearchFormPropsInterface> = (props) => (
  <ModalComponent
    openOnLoad
    showFooter={false}
    bodyClassName={'save-search-section__body'}
    contentClassName={'save-search-section__content'}
    title={props.title}
    customModalImage={__('assets/common/save-search.svg')}
    onClose={props.onClose}
  >
    <SaveSearchFormSectionComponent {...props} />
  </ModalComponent>
);
